module.exports = __webpack_public_path__ + "static/media/declaration-form-step1.dc42a4e1.svg";